/**
 * Custom Variant Picker
 * Handles variant selection via card clicks
 */

class CustomVariantPicker extends HTMLElement {
  constructor() {
    super();
    this.variants = [];
    this.currentVariantId = null;
  }

  connectedCallback() {
    this.initializeVariants();
    this.attachEventListeners();
  }

  initializeVariants() {
    const cards = this.querySelectorAll('.custom-variant-card');
    cards.forEach(card => {
      const variantId = card.dataset.variantId;
      const isAvailable = card.dataset.variantAvailable === 'true';

      this.variants.push({
        id: variantId,
        element: card,
        available: isAvailable
      });

      if (card.classList.contains('custom-variant-card--selected')) {
        this.currentVariantId = variantId;
      }
    });
  }

  attachEventListeners() {
    this.variants.forEach(variant => {
      if (variant.available) {
        variant.element.addEventListener('click', () => {
          this.selectVariant(variant.id);
        });
      }
    });
  }

  selectVariant(variantId) {
    // Don't do anything if already selected
    if (variantId === this.currentVariantId) {
      return;
    }

    // Update visual state
    this.variants.forEach(variant => {
      if (variant.id === variantId) {
        variant.element.classList.add('custom-variant-card--selected');
      } else {
        variant.element.classList.remove('custom-variant-card--selected');
      }
    });

    // Update hidden input
    const input = this.querySelector('.custom-variant-picker__input');
    if (input) {
      input.value = variantId;
    }

    // Update form input if exists
    const productForm = this.closest('product-info') || document.querySelector('product-info');
    if (productForm) {
      const formInput = productForm.querySelector('input[name="id"]');
      if (formInput) {
        formInput.value = variantId;

        // Dispatch change event to trigger product info update
        formInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Update URL
    this.updateURL(variantId);

    // Store current selection
    this.currentVariantId = variantId;
  }

  updateURL(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
  }
}

customElements.define('custom-variant-picker', CustomVariantPicker);
